/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class SwalAlertService {
  constructor(private _translateService: TranslateService) {}

  swalAlert(type: string): Promise<any> {
    return new Promise<any>(resolve => {
      Swal.fire({
        title: this._translateService.instant('AreYouSure'),
        text: this._translateService.instant(
          type === 'logout' ? 'Youwillbeloggedout' : 'WontBeAbleToRevert'
        ),
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: this._translateService.instant('Cancel'),
        confirmButtonColor: '#5a5a5a',
        cancelButtonColor: '#000',
        confirmButtonText: this._translateService.instant(
          type === 'logout' ? 'Logout' : 'DeleteIt'
        )
      }).then((result: any) => {
        return resolve(result);
      });
    });
  }
}
